import { get } from "./request";
import { buildApiUrl, API_CONFIG } from "./config";
import type { ApiResponse, ThreadDetail } from "./types";

// 单一页面相关API
export const pageApi = {
  /**
   * 获取页面帖子列表
   * @param tag_id - 标签id
   * @param language - 语言
   * @param page_id - 页面id
   * @param page - 页码，默认1
   * @param page_size - 每页数据量，默认10
   * @param order_by - 排序。两个值 dateline（发布时间）、lastpost（最新回复时间）
   * @returns Promise<ApiResponse<ThreadDetail[]>>
   */
  getPageThread: (
    tag_id?: number,
    page_id?: number,
    order_by?: "dateline" | "lastpost",
    language: string,
    page: number = 1,
    page_size: number = 10,
    game_id: number
  ): Promise<ApiResponse<ThreadDetail[]>> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.PAGE,
      API_CONFIG.ACTIONS.GET_PAGE_THREAD,
      {
        tag_id,
        page_id,
        order_by,
        page,
        page_size,
        target_language: language,
        game_id,
      }
    );
    return get<ApiResponse<ThreadDetail[]>>(url);
  },
};
